import { z } from "zod";

export type ThemeColor =
  "primary" | "secondary" | "error" | "warning" | "info" | "success";

const ContentWidthSchema = z.enum(["full", "boxed"]);

export type ContentWidth = z.infer<typeof ContentWidthSchema>;

export const SettingsSchema = z.object({
  themeColor: z.string(),
  contentWidth: ContentWidthSchema,
});

export type Settings = z.infer<typeof SettingsSchema>;

export type SettingsContextValue = {
  settings: Settings;
  saveSettings: (updatedSettings: Settings) => void;
};

declare module "@mui/material/styles" {
  interface Palette {
    customColors: {
      main: string;
      tableHeaderBg: string;
      primaryGradient: string;
    };
  }
  interface PaletteOptions {
    customColors?: {
      main?: string;
      tableHeaderBg?: string;
      primaryGradient?: string;
    };
  }
}
